<template>
  <section>

    <div class="columns is-vcentered is-centered" style="min-height: 100vh;">
      <div class="column is-two-fifths-desktop is-three-fifths-tablet">

        <div class="card" style="padding: 35px 30px;">
        <div class="card-content">

          <b-field label="Username" style="text-align: left;">
            <b-input v-model="username" @keyup.native.enter="triggerLogin" v-focus icon-pack="fas" placeholder="Your email address"></b-input>
          </b-field>

          <b-field label="Password" style="text-align: left; margin-top: 30px;">
            <b-input v-model="password" @keyup.native.enter="triggerLogin" type="password" icon-pack="fas" password-reveal placeholder="Your password"></b-input>
          </b-field>


          <p v-if="failedLogin" style="margin-top: 27px; text-align: left; color: red;">Invalid email or password.</p>


          <div style="text-align: right;">
            <button class="button is-primary" style="margin-top: 25px; margin-bottom: -10px;" @click="triggerLogin">Login to Dashboard</button>
          </div>
        </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  data: () => {
    return {
      username: '',
      password: ''
    }
  },
  computed: {
    failedLogin: function() {
      return (!this.$store.state.loginInProgress && this.$store.state.loginFailed);
    }
  },
  methods: {
    triggerLogin: function() {
      this.$store.dispatch('authenticate', { username: this.username, password: this.password });
    }
  }
}
</script>
